export default {
  feature_categories: []
}
